import type { FaireProductEntity } from "../../entity_types/product";

export const p_q94unhgy8v: FaireProductEntity = {
  token: "p_q94unhgy8v",
  type: "product",
  name: "Massage Candle - Fleurir",
  brandToken: "b_phyk4zwbt3",
  brandName: "Mienne",
  imageUrl:
    "https://cdn.faire.com/fastly/4d72fc67c1693d8b99f6d15ddf2bb1b59e56d0a150a49c5f26319883b1752fcf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a796e8c0333c069b1edc01017f82d3e5400b02f40627a81f6303093a17915964.jpeg",
    "https://cdn.faire.com/fastly/0a0fcefd221633529a6d5b7e3ea0b2bdb3b3754dfb3b081e6ba91aa95b718403.jpeg",
    "https://cdn.faire.com/fastly/7522f9fb7b6a616a8e1958c6c1842ca038d3f1c598dc2aa8b798f951314a9e0f.jpeg",
    "https://cdn.faire.com/fastly/a9607a8ca0275ebdc00bd95f8697f0d3940a99e8ac735a0ef9a9020fcd9a3cd6.jpeg",
    "https://cdn.faire.com/fastly/9f4e6f8d0b09464bb0048946145d01ea616e75e06b37499cf6a3f6409d5db611.jpeg",
  ],
  priceDollars: 22.75,
  description:
    "A candle that melts into a warm, nourishing oil to soften and hydrate skin. The botanical wax blend transforms from ambiance to touch, melting evenly into a silken pool infused with mood-shifting notes. Designed to pour effortlessly into the palm, the creamy oil absorbs on contact, while two signature scents deepen connection through the senses. Soft light, soft touch—one fully embodied ritual.\n",
  tags: [],
  msrpDollars: 65,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:32:40.257Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
